import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { DailyRouteDivertComponent } from "./dailyroutedivert/dailyroutedivert.component";
import { DayWiseCallComponent } from "./daywisecall/daywisecall.component";
import { DcrUnlockHistoryComponent } from "./dcrunlockhistory/dcrunlockhistory.component";
import { EmployeeWiseChemistComponent } from "./employeewisechemist/employeewisechemist.component";
import { UserReportComponent } from "./userreport/userreport.component";

import { HeadqtrAllocationReportComponent } from "./headqtrallocationreport/headqtrallocationreport.component";
import { HQWisePOBReportComponent } from "./hqwisepobreport/hqwisepobreport.component";
import { JointWorkingCallComponent } from "./jointworkingcall/jointworkingcall.component";
import { LiveAreaTrackingComponent } from "./liveareatracking/liveareatracking.component";
import { LoggeUunoggedReportComponent } from "./loggedunloggedreport/loggedunloggedreport.component";
import { ManagerTeamWiseCallComponent } from "./managerteamwisecall/managerteamwisecall.component";
import { MapTrackingComponent } from "./maptracking/maptracking.component";
import { POBComponent } from "./pob/pob.component";
import { PromotionalChemistReportComponent } from "./promotionalchemistreport/promotionalchemistreport.component";
import { TPDeviationReportComponent } from "./tpdeviationreport/tpdeviationreport.component";
import { NewRetallerAddition } from "./newretalleraddition/newretalleraddition.component";
import { TargetAndAchievementComponent } from './targetandachievement/targetandachievement.component';
import { leaveReportComponent } from "./leaveReport/leaveReport.component";
import { EmployeeAttendaceComponent } from "./userreport/employeeattendace.component";
import { AuthGuard } from '../../components/auth/auth-guard.service';
import { FirstLastComponent } from "./firstlastcall/firstlastcall.component";
import { LateWorkingReportComponent } from "./lateworking/lateworkingreport.component";
import { ExpenseEligiblityReportComponent } from "./expenseeligiblityreport/expenseeligiblity.component";
import { DailyExpenseReportComponent } from "./dailyexpensereport/dailyexpense.component";
import { NonListedCallComponent } from "./nonlistedcall/nonlistedcall.component";
import { SSStatementReportComponent } from "./ssstatementreport/ssstatementreport.component";
import { SSStatementlogComponent } from './ssstatementlog/ssstatementlog.component';


const mainRoutes: Routes = [

    { path: 'pob', canActivate: [AuthGuard], component: POBComponent },
    { path: 'liveareatracking', canActivate: [AuthGuard], component: LiveAreaTrackingComponent },
    { path: 'maptrackingtracking', canActivate: [AuthGuard], component: MapTrackingComponent },
    { path: 'daywisecall', canActivate: [AuthGuard], component: DayWiseCallComponent },
    { path: 'jointworkingcall', canActivate: [AuthGuard], component: JointWorkingCallComponent },
    { path: 'managerteamwisecall', canActivate: [AuthGuard], component: ManagerTeamWiseCallComponent },
    { path: 'dailyroutedivert', canActivate: [AuthGuard], component: DailyRouteDivertComponent },
    { path: 'tpdeviationreport', canActivate: [AuthGuard], component: TPDeviationReportComponent },
    { path: 'headqtrallocationreport', canActivate: [AuthGuard], component: HeadqtrAllocationReportComponent },
    { path: 'loggedunloggedreport', canActivate: [AuthGuard], component: LoggeUunoggedReportComponent },
    { path: 'SSStatementreport', canActivate: [AuthGuard], component: SSStatementReportComponent },
    { path: 'dcrunlockhistory', canActivate: [AuthGuard], component: DcrUnlockHistoryComponent },
    { path: 'promotionalchemistreport', canActivate: [AuthGuard], component: PromotionalChemistReportComponent },
    { path: 'hqwisepobreport', canActivate: [AuthGuard], component: HQWisePOBReportComponent },
    { path: 'employeewisechemist', canActivate: [AuthGuard], component: EmployeeWiseChemistComponent },
    { path: 'userreport', canActivate: [AuthGuard], component: UserReportComponent },
    { path: 'newretalleraddition', canActivate: [AuthGuard], component: NewRetallerAddition },
    { path: 'targetandacheivement', canActivate: [AuthGuard], component: TargetAndAchievementComponent },
    { path: 'leaveReport', canActivate: [AuthGuard], component: leaveReportComponent },
    { path: 'employeeattendace', canActivate: [AuthGuard], component: EmployeeAttendaceComponent },
    { path: 'firstlastcall', canActivate: [AuthGuard], component: FirstLastComponent },
    { path: 'lateworkingreport', canActivate: [AuthGuard], component: LateWorkingReportComponent },
    { path: 'expenseeligiblity', canActivate: [AuthGuard], component: ExpenseEligiblityReportComponent },
    { path: 'dailyexpense', canActivate: [AuthGuard], component: DailyExpenseReportComponent },
    { path: 'nonlistedcall', canActivate: [AuthGuard], component: NonListedCallComponent },
    { path: 'ssstatementreport', canActivate: [AuthGuard], component: SSStatementReportComponent },
    { path: 'ssstatementreportlog', canActivate: [AuthGuard], component: SSStatementlogComponent },
    

]
@NgModule({
    imports: [RouterModule.forChild(mainRoutes)],
    exports: [RouterModule]
})
export class ReportsRoutingModule {

}